import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { Observable } from 'rxjs';

@Injectable()
export class DeviceTokenService {
  private $api: string = '';

  constructor(private $ajax: AjaxService) {
    this.$api = this.$ajax.getAPIDomain();
  }

  /**
   * 사용자의 디바이스 토큰 정보 반환
   */
  hasDeviceToken(): Promise<{
    token: string,
  }> {
    return this.$ajax.httpRequest(
        'GET',
        this.$api + 'user/device-token',
    ).toPromise();
  }

  /**
   * 디바이스 토큰 등록
   */
  registerDeviceToken(token: string): Observable<any> {
    return this.$ajax.httpRequest(
        'PUT',
        this.$api + `user/device-token/${token}`,
    );
  }
}
